import { Box } from '@breathelife/mui';
import styled from '../../../../../../Styles/themed-styled-components';
import { HEADER_HEIGHT_PX } from '../../../../AssistedApplicationLayout/AssistedApplicationLayout';

export const LoaderContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  min-height: 400px;
`;

export const ErrorContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  text-align: center;
  gap: 16px;
`;

export const ErrorTitle = styled.h2`
  color: #d32f2f;
  font-size: 24px;
  font-weight: 600;
  margin: 0;
`;

export const ErrorMessage = styled.p`
  color: #616161;
  font-size: 16px;
  line-height: 1.5;
  margin: 0;
  max-width: 500px;
`;

export const HeaderTitle = styled.h2`
  font-size: 18px;
  font-family: inherit;
  font-weight: 600;
  line-height: 21px;
  color: ${(props) => props.theme.colors.grey[90]};
  margin: 0;
`;

export const CustomSubmitButton = styled.button`
  background-color: ${(props) => props.theme.colors.primary[50]};
  color: white;
  border-radius: 5%;
  border: none;
  padding: 12px 20px;
  cursor: pointer;
  font-weight: 500;
  min-width: 100px;

  &:disabled {
    background-color: ${(props) => props.theme.colors.primary[50]};
    opacity: 0.5;
    cursor: not-allowed;
  }

  &:hover {
    background-color: ${(props) => props.theme.colors.primary[60]};
    box-shadow:
      rgba(0, 0, 0, 0.2) 0px 2px 4px -1px,
      rgba(0, 0, 0, 0.14) 0px 4px 5px 0px,
      rgba(0, 0, 0, 0.12) 0px 1px 10px 0px;
  }
`;

export const AuraNextForm = styled(Box)`
  height: 100%;
  width: 100%;

  #deuiApp {
    font-family: ${(props) => props.theme.fonts.family.fallbacks};

    @media (max-width: ${(props) => props.theme.moduleBreakpoints.sm}) {
      overflow: scroll;
      scroll-behavior: smooth;
      height: 83%;
    }

    > div {
      display: flex;
      flex-direction: row;

      @media (max-width: ${(props) => props.theme.moduleBreakpoints.sm}) {
        flex-direction: column;
      }

      > .row {
        // Navigation bar
        &:nth-child(1) {
          flex: 1;
          padding: 24px;

          @media (max-width: ${(props) => props.theme.moduleBreakpoints.sm}) {
            padding-bottom: 0;
          }

          ul {
            flex-direction: column;

            li {
              list-style: none;
              border: 1px solid transparent;
              border-radius: 3px;
              margin-bottom: 10px;

              a {
                padding: 10px;
                color: ${(props) => props.theme.colors.grey[70]};
                display: flex;
                align-items: flex-start;
                font-weight: 500;
                text-align: start;
                text-decoration: none !important;
              }

              &:hover {
                color: ${(props) => props.theme.colors.grey[90]};
                background-color: ${(props) => props.theme.colors.grey[20]};
              }

              &:has(> a.activeSection) {
                background-color: ${(props) => props.theme.colors.primary[20]};
                border-color: ${(props) => props.theme.colors.primary[30]};

                a {
                  border-color: ${(props) => props.theme.colors.default};
                  color: ${(props) => props.theme.colors.grey[90]};
                }
              }

              &:has(> a.complete) {
                a::after {
                  content: '\\2713';
                  color: ${(props) => props.theme.colors.success};
                  font-weight: 700;
                  position: relative;
                  right: -10px;
                  top: 0;
                }
              }
            }
          }
        }

        // Form Container
        &:nth-child(2) {
          height: calc(100vh - ${HEADER_HEIGHT_PX}px);
          overflow: auto;
          scroll-behavior: smooth;
          flex: 3;
          border-left: 1px solid ${(props) => props.theme.colors.grey[30]};

          .sectionQuestionLayout.container-fluid {
            max-width: 700px;
            display: flex;
            justify-content: flex-start;
            padding: 0;
            margin: 40px 0 40px 50px;

            @media (max-width: ${(props) => props.theme.moduleBreakpoints.sm}) {
              max-width: 100%;
              margin: 0;
            }

            > .row > .col-sm-12 {
              @media (max-width: ${(props) => props.theme.moduleBreakpoints.sm}) {
                max-width: 100%;
                margin: 20px;
              }
            }

            // Main navigation Buttons
            .deuiButtonNav,
            .deuiButtonEnabled {
              display: none;
            }

            .repeaterQuestionGroupLabel {
              vertical-align: middle;
            }

            .removeRepeaterQuestionGroup {
              display: inline-block;
              margin-left: -4px;
            }

            .questionnaire-nav {
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              align-items: center;

              #previousSectionBtn,
              #nextSectionBtn {
                display: block;
                color: ${(props) => props.theme.colors.grey[20]};
                background-color: ${(props) => props.theme.colors.primary.default};
                text-shadow: none;

                &:hover {
                  background-color: ${(props) => props.theme.colors.primary[70]};
                  box-shadow: none;
                  border-color: ${(props) => props.theme.colors.primary[70]};
                }
              }
            }

            // Divider
            .deuiLineBreak {
              background-color: ${(props) => props.theme.colors.grey[40]};
              height: 1px;
              border: 0;
            }

            // Subtitles
            .deuiParentChoiceContext {
              font-size: 16px;
              font-weight: 600;
              text-transform: uppercase;
              color: ${(props) => props.theme.colors.primary.default};
            }

            // Errors
            .has-error .help-block,
            .has-error .control-label,
            .has-error .radio,
            .has-error .checkbox,
            .has-error .radio-inline,
            .has-error .checkbox-inline,
            .has-error.radio label,
            .has-error.checkbox label,
            .has-error.radio-inline label,
            .has-error.checkbox-inline label {
              color: ${(props) => props.theme.colors.red[50]};
            }

            // All fields with text input
            input[type='text'] {
              min-width: 150px;
              margin-right: 10px;
              border-radius: 3px;

              @media (max-width: ${(props) => props.theme.moduleBreakpoints.sm}) {
                min-width: 100%;
              }

              &:focus-visible {
                outline: transparent;
                border-color: ${(props) => props.theme.colors.primary.default};
              }

              &:hover {
                border-color: ${(props) => props.theme.colors.grey[80]};
                box-shadow: none;
              }
            }

            // Tooltip
            .questionHelpTextTooltipIcon {
              color: ${(props) => props.theme.colors.primary.default};
              font-size: 17px;
            }

            // Form Elements
            .form-group {
              margin: 24px 0;

              // Field Title
              .deuiQuestText {
                color: ${(props) => props.theme.colors.grey[90]};
                font-size: 17px;
                font-weight: bold;
                padding-bottom: 15px;
                margin: 0;
              }

              // Radio Field
              .deuiRadioResp {
                > span {
                  min-width: 200px;
                  padding: 15px;
                  background-color: ${(props) => props.theme.colors.grey[20]};
                  border-radius: 3px;
                  margin-right: 10px;
                  margin-bottom: 10px;

                  &:hover {
                    cursor: pointer;
                    * {
                      cursor: pointer;
                    }
                  }
                }

                @media (max-width: ${(props) => props.theme.moduleBreakpoints.sm}) {
                  flex-direction: column;
                }

                .deuiRadio {
                  height: 100%;
                  display: flex;
                  align-items: center;

                  label {
                    margin-bottom: 0;
                  }

                  de-question-text {
                    top: 0;
                  }

                  .radioLabel::before {
                    font-size: 36px;
                    padding: 1px;
                    border: 2px solid ${(props) => props.theme.colors.grey[60]};
                    margin-top: 0;
                    margin-right: 10px;
                  }

                  &.deuiChecked {
                    .radioLabel::before {
                      border-color: ${(props) => props.theme.colors.primary.default};
                      color: ${(props) => props.theme.colors.primary.default};
                    }
                  }

                  &:hover:not(.deuiChecked) {
                    .radioLabel::before {
                      background-color: ${(props) => props.theme.colors.grey[40]};
                    }
                  }
                }
              }

              // Checkbox Field
              .deuiCheckboxRespWidget {
                > div {
                  margin-bottom: 10px;
                  padding: 15px;
                  background-color: ${(props) => props.theme.colors.grey[20]};
                  border-radius: 3px;

                  &:hover {
                    cursor: pointer;
                    * {
                      cursor: pointer;
                    }
                  }

                  .deuiCheckbox {
                    .checkboxTxt {
                      align-items: center;

                      ::before {
                        font-size: 13px;
                        padding: 1px;
                        border: 2px solid ${(props) => props.theme.colors.grey[70]};
                        border-radius: 3px;
                        margin-top: 0;
                        margin-right: 10px;
                      }
                    }

                    &.deuiChecked {
                      .checkboxTxt::before {
                        background-color: ${(props) => props.theme.colors.primary.default};
                        color: ${(props) => props.theme.colors.grey[30]};
                        border-color: ${(props) => props.theme.colors.primary.default};
                      }
                    }

                    &:hover:not(.deuiChecked) {
                      .checkboxTxt::before {
                        background-color: ${(props) => props.theme.colors.grey[40]};
                      }
                    }
                  }
                }
              }

              // Textarea Field
              .textAreaRespWidget {
                &:focus-visible {
                  outline: transparent;
                }

                textarea {
                  width: 700px;
                  height: 100%;
                  padding: 15px;
                  border-radius: 5px;
                  border: 1px solid ${(props) => props.theme.colors.grey[50]};
                  resize: none;
                  transition: none;
                  box-shadow: none;
                  font-size: 15px;

                  @media (max-width: ${(props) => props.theme.moduleBreakpoints.sm}) {
                    width: 100%;
                  }

                  &:hover {
                    border-color: ${(props) => props.theme.colors.grey[80]};
                    box-shadow: none;
                  }

                  &:focus-visible {
                    border-color: transparent;
                    outline: 2px solid ${(props) => props.theme.colors.primary.default};
                    box-shadow: none;
                    transition: none;
                  }

                  &:focus {
                    box-shadow: none;
                  }
                }
              }

              // Numeric Text Field
              .numericRespWidget input[type='text'] {
                width: 100%;
                height: 40px;
                font-size: 15px;
                border-radius: 5px;
                border: 1px solid ${(props) => props.theme.colors.grey[50]};

                &:focus-visible {
                  outline: 2px solid ${(props) => props.theme.colors.primary.default};
                }

                &:hover {
                  border-color: ${(props) => props.theme.colors.grey[80]};
                  box-shadow: none;
                }
              }

              // Select Search Field
              .searchRespWidget {
                width: 100% !important;
                .MuiAutocomplete-root {
                  border: 1px solid ${(props) => props.theme.colors.grey[50]};
                  outline: 2px solid transparent;

                  &.Mui-focused {
                    border-color: transparent;
                    outline: 2px solid ${(props) => props.theme.colors.primary.default};
                  }

                  label {
                    height: auto;
                    font-weight: normal;

                    &.MuiInputLabel-root {
                      top: -7px !important;
                    }

                    &.MuiInputLabel-shrink {
                      transform: translate(23px, 0px) scale(0.8);
                    }

                    &.Mui-focused {
                      color: ${(props) => props.theme.colors.primary.default};
                    }
                  }

                  .MuiInputBase-root {
                    padding: 5px !important;

                    input {
                      font-size: 15px !important;
                    }
                  }
                }
              }

              // Multichoices Percentage Field
              .multiChoicePercentRespWidget {
                > div {
                  margin-bottom: 15px;

                  input {
                    border: 1px solid ${(props) => props.theme.colors.grey[50]};
                    outline: 2px solid transparent;
                    height: 40px;
                    padding: 10px;
                    font-size: 15px;
                    min-width: 80px;

                    &:focus,
                    &:focus-visible {
                      outline: 2px solid ${(props) => props.theme.colors.primary.default};
                      border-color: transparent;
                    }

                    &:hover {
                      border-color: ${(props) => props.theme.colors.grey[80]};
                      box-shadow: none;
                    }
                  }
                }

                label.ng-binding {
                  padding: 10px;
                  border: 2px solid ${(props) => props.theme.colors.grey[50]};
                  background-color: ${(props) => props.theme.colors.grey[20]};
                }
              }

              // Date picker Field
              .dateRespWidget {
                .deuiSelect {
                  outline: 2px solid transparent;
                  border-color: ${(props) => props.theme.colors.grey[50]};

                  &:hover {
                    box-shadow: none;
                    border-color: ${(props) => props.theme.colors.grey[80]};
                  }

                  .MuiAutocomplete-root {
                    border: none;
                  }

                  input {
                    padding: 11px !important;
                    font-size: 15px !important;
                  }

                  .Mui-focused:not(label) {
                    border-color: transparent;
                    outline: 2px solid ${(props) => props.theme.colors.primary.default} !important;
                  }

                  label {
                    font-weight: normal;
                    &.Mui-focused {
                      color: ${(props) => props.theme.colors.primary.default};
                    }
                  }
                }

                .datePickerInput {
                  margin-top: 0;
                  padding: 19px;

                  &:hover {
                    border-color: ${(props) => props.theme.colors.grey[80]};
                    box-shadow: none;
                  }

                  .MuiInputBase-root {
                    top: -17px;
                    height: 40px;

                    input {
                      font-size: 15px;
                      padding: 0;
                      width: 100%;
                      height: 100%;
                    }
                  }
                }

                .deuiTextField {
                  min-width: 100px;
                  padding: 21px;
                  font-size: 15px;
                  box-shadow: none;
                  transition: none;
                }
              }

              // Unitized Field
              .unitizedRespWidget {
                display: flex;

                @media (max-width: ${(props) => props.theme.moduleBreakpoints.sm}) {
                  align-items: flex-start;
                  flex-direction: column;
                  > * {
                    margin-bottom: 10px;
                  }
                }

                input[type='text'].deuiTextField {
                  height: 40px;
                  font-size: 15px;
                  min-width: 100px;
                  border-radius: 5px;
                  border: 1px solid ${(props) => props.theme.colors.grey[50]};

                  &:focus-visible {
                    outline: 2px solid ${(props) => props.theme.colors.primary.default};
                  }

                  &:hover {
                    border-color: ${(props) => props.theme.colors.grey[80]};
                    box-shadow: none;
                  }
                }

                .deuiSelect {
                  outline: 2px solid transparent;
                  border-color: ${(props) => props.theme.colors.grey[50]};

                  &:hover {
                    box-shadow: none;
                    border-color: ${(props) => props.theme.colors.grey[80]};
                  }

                  .MuiAutocomplete-root {
                    border: none;
                  }

                  input {
                    padding: 11px !important;
                    font-size: 15px !important;
                  }

                  .Mui-focused:not(label) {
                    border-color: transparent;
                    outline: 2px solid ${(props) => props.theme.colors.primary.default} !important;
                  }

                  label {
                    font-weight: normal;
                    &.Mui-focused {
                      color: ${(props) => props.theme.colors.primary.default};
                    }
                  }
                }
              }

              // Multiple Choice
              .multipleChoiceRespWidget {
                .deuiDiscloseDetailsQuestionGroup {
                  margin-bottom: 15px;

                  label {
                    font-weight: normal;
                    margin-top: 3px;
                    margin-bottom: 10px;
                  }

                  .deuiSelect {
                    outline: 2px solid transparent;
                    border-color: ${(props) => props.theme.colors.grey[50]};

                    &:hover {
                      box-shadow: none;
                      border-color: ${(props) => props.theme.colors.grey[80]};
                    }

                    .MuiAutocomplete-root {
                      border: none;
                    }

                    input {
                      padding: 11px !important;
                      font-size: 15px !important;
                    }

                    .Mui-focused:not(label) {
                      border-color: transparent;
                      outline: 2px solid ${(props) => props.theme.colors.primary.default} !important;
                    }

                    label {
                      font-weight: normal;

                      &.Mui-focused {
                        color: ${(props) => props.theme.colors.primary.default};
                      }
                    }
                  }
                }
              }

              // Doctor Widget
              .doctorRespWidget {
                .input-group {
                  .MuiAutocomplete-root .MuiInputBase-input {
                    font-size: 15px !important;
                    padding: 11px !important;
                  }

                  .input-group-btn .deuiButton {
                    padding: 9px 12px;
                    background: ${(props) => props.theme.colors.grey[30]} !important;

                    &:hover {
                      box-shadow: none;
                      background: ${(props) => props.theme.colors.grey[50]} !important;
                    }
                  }
                }

                label {
                  font-weight: normal;
                  margin-bottom: 10px;
                  font-size: 15px;
                  color: ${(props) => props.theme.colors.grey[90]};
                }

                input[type='text'].deuiTextField {
                  height: 40px;
                  font-size: 15px !important;
                  min-width: 100px;
                  border-radius: 5px;
                  border: 1px solid ${(props) => props.theme.colors.grey[50]};

                  &:focus-visible {
                    outline: 2px solid ${(props) => props.theme.colors.primary.default};
                  }

                  &:hover {
                    border-color: ${(props) => props.theme.colors.grey[80]};
                    box-shadow: none;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
